import type { ExpertAssistMessage } from "../shared-types";

export const baseDefaultMessage = {
    type: "Default",
    status: "active",
    isUnread: true,
};

export const fallbackDefaultMessages = [
    {
        key: "firstOpen",
        text: `Hey $EXPERT_NAME! 👋 I have limited info until you're on a call, but can still help with some things.`,
        id: `firstOpen_${crypto.randomUUID()}`,
        tag: "New chat",
        ...baseDefaultMessage,
    },
    {
        key: "inCallDeviceInfo",
        text: "Need help troubleshooting? Ask away—I’m here to assist!",
        id: `newCall_${crypto.randomUUID()}`,
        tag: "New call",
        ...baseDefaultMessage,
    },
    {
        key: "manualReset",
        text: "The chat was reset. I’m ready to help!",
        id: `manualReset_${crypto.randomUUID()}`,
        ...baseDefaultMessage,
    },
    {
        key: "offCall",
        text: `I have limited info when you're off calls, but you can still ask me some stuff! How about a joke or 
dinner recipe? 🍝`,
        id: `offCall_${crypto.randomUUID()}`,
        tag: "Off-call chat",
        ...baseDefaultMessage,
    },
] as ExpertAssistMessage[];
export type ResetReason = keyof typeof fallbackDefaultMessages;
